export default "__VITE_ASSET__DrfgaL_S__"